import { Pipe, PipeTransform } from '@angular/core'
import _ from 'lodash'

/**
 * Returns HTML string with formated acreage value
 */
@Pipe({ name: 'displayAcreageString' })
export class DisplayAcreagePipe implements PipeTransform {
    transform(number: number, listStyle?: boolean, roundTo?: number): string {
        const unit = listStyle ? 'm<sup>2</sup>' : '<span class="textDescription">m<sup>2</sup></span>'

        if (!number) {
            return '0 ' + unit
        }

        if (!_.isNil(roundTo) && Number.isInteger(roundTo)) {
            number = +( parseFloat(number.toString() || '0').toFixed(roundTo || 0))
        }

        const pad = (n, width, z): string => {
            z = z || '0'
            n = n + ''
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
        }
        const sign = number < 0 ? '-' : ''
        number = Math.abs(Math.round(number * 10) / 10)

        if (number < 10000) {
            return sign + number + ' ' + unit
        } else {
            const nad = Math.floor(number / 10000)
            const za = number - Math.floor(number)
            const pod = pad(Math.floor(number) - nad * 10000, 4, null)
            return sign + nad + '&thinsp;' + pod + ((za > 0) ? '.' + Math.round(za * 10) : '') + ' ' + unit
        }
    }
}
